import { Injectable, computed, inject, signal } from '@angular/core';
import { AuthService } from '@/app/auth/auth.service';
import { RouteRegistry } from '@/app/auth/route-registry';
import { MenuItem } from '@/types/menuItem.interfaces';
import { Module } from '@/types/module.interfaces';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private auth = inject(AuthService);
  isSidebarExpanded = signal(true);

  private readonly ICON_MAP: Record<string, string> = {
    'Dashboard': 'pi-chart-pie',
    'Presence Management': 'pi-users',
    'Leave Management': 'pi-send',
    'Reimburse Management': 'pi-money-bill',
    'Biztrip Management': 'pi-map',
  };

  roleMenu = computed<MenuItem[]>(() => {
    const modules = this.auth.modules();

    const staticMenu: MenuItem[] = [
      {
        label: 'Dashboard',
        icon: 'pi pi-chart-pie',
        url: '/dashboard',
      }
    ];

    if (!modules) return staticMenu;

    const dynamicMenu = modules
      .map((mod: Module) => {
        const visibleFeatures = (mod.features ?? []).filter(
          feature => !!RouteRegistry[feature.path]
        );

        return {
          label: mod.title,
          icon: `pi ${this.ICON_MAP[mod.title] || 'pi-folder'}`,
          children: visibleFeatures.map(feature => ({
            label: this.cleanChildTitle(feature.title),
            url: feature.path,
            icon: 'pi pi-circle-fill',
          })),
        };
      })
      .filter(menu => menu.children && menu.children.length > 0);

    return [...staticMenu, ...dynamicMenu];
  });

  private cleanChildTitle(title: string): string {
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes('wfh/wfo')) return 'WFH/WFO';

    const words = title.split(' ');
    if (words[0].toLowerCase() === 'create') return words[0];

    return words.length > 1 ? words.slice(1).join(' ') : title;
  }

  getRoleMenuTitle() {
    return this.auth.userRole() || 'Menu';
  }

  user = computed(() => this.auth.user());
}
